module.exports = __webpack_public_path__ + "img/dcg3.f5a0abe0.jpg";